<template>
	<div class="home">
		<Encabezado></Encabezado>

		<div id="content" class="snap-content bg-home">
			<div class="container">
				<div class="header-clear"></div>
				<div id="itemList">
					<div class="itemList-controls">
						<div class="controls controls-left">
                            <router-link class="btn GeneralLeave-back btnBack" to="/vacaciones">
							    <font-awesome-icon icon="fa-solid fa-circle-chevron-left" /> Atrás
							</router-link>
                        </div>
						<div class="title">
							<h3>Vacaciones</h3>
						</div>
					</div>
                    <div class="itemList-header">
                        <!--<h1>Ver {{ registroVacaciones }}</h1>-->
                        <h1>Ver</h1>
                    </div>
                    <div id="Detail" class="detail-Generalleave">
                        <div class="row">
                            <div class="col-md-3 col-sm-6 col-xs-6">
                                <label for="">Fecha desde</label>
                                <p>{{ formatDate(registroVacaciones.fechaDesde) }}</p>
                            </div>
                            <div class="col-md-3 col-sm-6 col-xs-6">
                                <label for="">Fecha hasta</label>
                                <p>{{ formatDate(registroVacaciones.fechaHasta) }}</p>
                            </div> 
                            <div class="col-md-3 col-sm-6 col-xs-6">
                                <label for="">Total Días</label>
                                <p>{{ registroVacaciones.dias }}</p>
                            </div>
                            <div class="col-md-3 col-sm-6 col-xs-6">
                                <label for="">Estado</label>
                                <p>{{ registroVacaciones.estado }}</p>
                            </div>
                        </div>
                        
                        <hr />
                        <div class="row">
                            <div class="col-md-6 col-sm-6 col-xs-12">
                                <label for="">Observaciones</label>
                                <p>{{ registroVacaciones.observaciones }}</p>
                            </div>
                        </div>
                        <hr />
                        <div class="form-group">
                            
                            <label for="">Tramites:</label> 
                            <ul class="listaTramites" v-for="(vacacionesTramite, index) in vacacionesTramites">
                                <li>
                                    <!--<strong>
                                       <u>Tramite {{ vacacionesTramite.length - index }}</u>: {{ formatDate(vacacionesTramite.fecha) }} / {{ vacacionesTramite.usuario }} / {{ vacacionesTramite.estado }}
                                    </strong>-->
                                    <strong>
                                        <u>Tramite {{ vacacionesTramites.length - index }}</u>: {{ formatDate(vacacionesTramite.fecha) }} / {{ vacacionesTramite.estado }}
                                     </strong>
                                </li>
                                <div>
                                    <i>
                                        {{ vacacionesTramite.observacionesRRHH }}
                                    </i>
                                    <i>
                                        {{ vacacionesTramite.observacionesResponsable }}
                                    </i>
                                </div>
                            </ul>
                            
                        </div>
                    </div>
				</div>
			</div>
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<Footer></Footer>
		</div>
	</div>
</template>

<script>
    // @ is an alias to /src
    import Encabezado from "@/components/Encabezado.vue";
    import Footer from "@/components/Footer.vue";

    export default {
        name: "DetalleVacaciones",
		components: {
            Encabezado,
            Footer,
        },
		data() { 
			return{}
		},
		mounted() {
			document.body.classList.remove("bg-login");
			document.body.classList.remove("login-page");
		},
		computed:{
            registrosVacaciones: function(){
				let registrosVacaciones = this.$store.state.perfil.vacaciones.registros || [];
			
                return (Array.isArray(registrosVacaciones)? registrosVacaciones : [registrosVacaciones]);
			},
			registroVacaciones: function(){
                let registroVacaciones = null;

				if (this.registrosVacaciones.length > 0){
                    registroVacaciones = this.registrosVacaciones.find(registroVacaciones=>{
                        return registroVacaciones.id == this.$route.params.id_vacaciones;
                    });
				}

                return registroVacaciones;
			},
            vacacionesTramites:function(){
                let vacacionesTramites = this.registroVacaciones.tramites || [];

                return (Array.isArray(vacacionesTramites))? vacacionesTramites : [vacacionesTramites];
            }
		},
        methods:{
            formatDate: function (date) {
				return this.moment(date).format('DD/MM/YYYY hh:mm');
			}            
        }
    };
</script>

<style>
    @import "../assets/styles/home.css";
</style>
